'use strict';
define(['app'], function (app) {
    app.service('PlanDetailsService', PlanDetailsService);
    PlanDetailsService.$inject = [];

    function PlanDetailsService() {
        var self = this;

        /*
         * Le campagne principali sono calcolate ogni anno in base al calendario,
         * non a date o importi copiati a mano.
         */
        var PROMO_DEFINITIONS = {
            newyear: {
                name: 'New Year Promo',
                titleEmoji: '🎉',
                illustrationEmojis: ['🎆', '🥂'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'New Year Promo',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            backworkjan: {
                name: 'Back to Work January',
                titleEmoji: '💼',
                illustrationEmojis: ['💼', '☕'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Back to Work January',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            valentine: {
                name: 'Valentine Promo',
                titleEmoji: '❤️',
                illustrationEmojis: ['❤️', '🌹'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Valentine Promo',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            easter: {
                name: 'Easter Promo',
                titleEmoji: '🐣',
                illustrationEmojis: ['🥚', '🐰'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Easter Promo',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            summer: {
                name: 'Summer Promo',
                titleEmoji: '☀️',
                illustrationEmojis: ['⛱️', '🩴'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Summer Promo',
                languageVisibility: 'all',
                discount: 20,
                annualOnly: false
            },
            ferragosto: {
                name: 'Ferragosto Promo',
                titleEmoji: '🏖️',
                illustrationEmojis: ['🏖️', '🍉'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Ferragosto Promo',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            backworksep: {
                name: 'Back to Work September',
                titleEmoji: '📚',
                illustrationEmojis: ['📚', '💼'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Back to Work September',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            halloween: {
                name: 'Halloween Promo',
                titleEmoji: '🎃',
                illustrationEmojis: ['🎃', '👻'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: '',
                promoAlt: 'Halloween Promo',
                languageVisibility: 'all',
                discount: 30,
                annualOnly: false
            },
            black: {
                name: 'Black Friday Promo',
                titleEmoji: '🚀',
                illustrationEmojis: ['📈', '💻'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: 'blackfriday2022.svg',
                promoAlt: 'black friday',
                languageVisibility: 'all',
                discount: 50,
                annualOnly: true
            },
            cyber: {
                name: 'Cyber Monday Promo',
                titleEmoji: '💻',
                illustrationEmojis: ['👾', '⚡'],
                currentPromoModifierClass: 'black-friday-special',
                promoImgFile: 'cybermonday2022.svg',
                promoAlt: 'cyber monday',
                languageVisibility: 'all',
                discount: 50,
                annualOnly: true
            },
            christmas: {
                name: 'Christmas Promo',
                titleEmoji: '🎄',
                illustrationEmojis: ['🎄', '🎅'],
                currentPromoModifierClass: 'christmas-promo',
                promoImgFile: 'christmaspromo.svg',
                promoAlt: 'Christmas Promo',
                languageVisibility: 'all',
                discount: 40,
                annualOnly: false
            }
        };

        self.promoStack = buildPromoStackForYear(new Date().getFullYear());

        self.plans = [
            {
                name: 'Lite',
                type: 'Personal',
                runningOut: false,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 18,
                annualAmountDecimal: 0,
                monthlyAmount: 26,
                annualAmountSavedForYear: 96,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-lite-annual',
                monthlyAlias: 'plan-lite-monthly',
                features: [{
                    platform: {
                        users: 1,
                        projects: 1
                    },
                    seoAnalysis: {
                        analisysPerDay: 20,
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: false,
                        suggestionsWithAI: false,
                        contentGeneration: false,
                    },
                    ai: {
                        accessToTheTool: false,
                        aiCredits: false,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 250,
                        pagesCanBeAnalyzedByProject: 50,
                        dataRetention: '1 Month'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 150,
                        keywordPerDomainPerMonth: 150,
                        keywordList: 2
                    },
                    backlink: {
                        accessToTheTool: false,
                        backlinkRowsPerMonth: false,
                        analisysPerMonth: false,
                    },
                    positionMonitoring: {
                        trackedKeyword: 25,
                        updateFrequency: '7 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: false,
                        dowloadableReport: false,
                        whiteLabelSeoReports: false,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: false,
                        leadGenWhitelabelReports: false,
                    },
                    writeAssistant: {
                        accessToTheTool: false,
                        suggestionsWithAI: false,
                        contentGeneration: false,
                    },
                },],
                textualTarget: "for.those.who.want.to.start.with.seo",
                textualFeatures: [
                    "on.page.seo.audit",
                    "keyword.research",
                    "1.seo.project",
                    ""
                ]
            },
            {
                name: 'Pro',
                type: 'Personal',
                runningOut: false,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 26,
                annualAmountDecimal: 0,
                monthlyAmount: 38,
                annualAmountSavedForYear: 144,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-pro-annual',
                monthlyAlias: 'plan-pro-monthly',
                features: [{
                    platform: {
                        users: 1,
                        projects: 2
                    },
                    seoAnalysis: {
                        analisysPerDay: 100,
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: true,
                        suggestionsWithAI: true,
                        contentGeneration: true,
                    },
                    ai: {
                        accessToTheTool: true,
                        aiCredits: 60,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 2500,
                        pagesCanBeAnalyzedByProject: 500,
                        dataRetention: '3 Month'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 1500,
                        keywordPerDomainPerMonth: 1500,
                        keywordList: 10
                    },
                    backlink: {
                        accessToTheTool: true,
                        backlinkRowsPerMonth: 25000,
                        analisysPerMonth: 100,
                    },
                    positionMonitoring: {
                        trackedKeyword: 150,
                        updateFrequency: '7 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: 10,
                        dowloadableReport: 5,
                        whiteLabelSeoReports: false,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: 10,
                        leadGenWhitelabelReports: false,
                    },
                },],
                textualTarget: "for.smb.and.startup",
                textualFeatures: [
                    "all.the.lite.features",
                    "extended.limits",
                    "seo.content.analysis",
                    "seo.reports"
                ]
            },
            {
                name: 'Plus',
                type: 'Personal',
                runningOut: true,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 38,
                annualAmountDecimal: 0,
                monthlyAmount: 56,
                annualAmountSavedForYear: 216,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-plus-annual',
                monthlyAlias: 'plan-plus-monthly',
                features: [{
                    platform: {
                        users: 1,
                        projects: 5
                    },
                    seoAnalysis: {
                        analisysPerDay: 200,
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: true,
                        suggestionsWithAI: true,
                        contentGeneration: true,
                    },
                    ai: {
                        accessToTheTool: true,
                        aiCredits: 300,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 10000,
                        pagesCanBeAnalyzedByProject: 2000,
                        dataRetention: '3 Month'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 5000,
                        keywordPerDomainPerMonth: 5000,
                        keywordList: 25
                    },
                    backlink: {
                        accessToTheTool: true,
                        backlinkRowsPerMonth: 50000,
                        analisysPerMonth: 200,
                    },
                    positionMonitoring: {
                        trackedKeyword: 500,
                        updateFrequency: '7 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: 50,
                        dowloadableReport: 25,
                        whiteLabelSeoReports: true,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: 20,
                        leadGenWhitelabelReports: true,
                    }
                },],
                textualTarget: "for.seo.consultant",
                textualFeatures: [
                    "all.the.pro.features",
                    "extended.limits",
                    "white.label.reports",
                    "5.seo.projects"
                ]
            },
            {
                name: 'Advanced',
                type: 'Agency',
                runningOut: true,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 48,
                annualAmountDecimal: 0,
                monthlyAmount: 72,
                annualAmountSavedForYear: 288,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-advanced-annual',
                monthlyAlias: 'plan-advanced-monthly',
                features: [{
                    platform: {
                        users: 5,
                        projects: 15
                    },
                    seoAnalysis: {
                        analisysPerDay: 500,
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: true,
                        suggestionsWithAI: true,
                        contentGeneration: true,
                    },
                    ai: {
                        accessToTheTool: true,
                        aiCredits: 750,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 50000,
                        pagesCanBeAnalyzedByProject: 5000,
                        dataRetention: '3 Month'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 10000,
                        keywordPerDomainPerMonth: 20000,
                        keywordList: 50
                    },
                    backlink: {
                        accessToTheTool: true,
                        backlinkRowsPerMonth: 100000,
                        analisysPerMonth: 400,
                    },
                    positionMonitoring: {
                        trackedKeyword: 1000,
                        updateFrequency: '7 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: 100,
                        dowloadableReport: 50,
                        whiteLabelSeoReports: true,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: 50,
                        leadGenWhitelabelReports: true,
                    }
                },],
                textualTarget: "for.growing.seo.and.ppc.agencies",
                textualFeatures: [
                    "5.users.included",
                    "15.seo.projects",
                    "50.white.label.reports",
                    ""
                ]
            },
            {
                name: 'Premium',
                type: 'Agency',
                runningOut: false,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 96,
                annualAmountDecimal: 0,
                monthlyAmount: 144,
                annualAmountSavedForYear: 576,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-premium-annual',
                monthlyAlias: 'plan-premium-monthly',
                features: [{
                    platform: {
                        users: 10,
                        projects: 50
                    },
                    seoAnalysis: {
                        analisysPerDay: 2000,
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: true,
                        suggestionsWithAI: true,
                        contentGeneration: true,
                    },
                    ai: {
                        accessToTheTool: true,
                        aiCredits: 1500,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 500000,
                        pagesCanBeAnalyzedByProject: 10000,
                        dataRetention: '6 Months'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 25000,
                        keywordPerDomainPerMonth: 50000,
                        keywordList: 100
                    },
                    backlink: {
                        accessToTheTool: true,
                        backlinkRowsPerMonth: 250000,
                        analisysPerMonth: 1000,
                    },
                    positionMonitoring: {
                        trackedKeyword: 2500,
                        updateFrequency: '5 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: 250,
                        dowloadableReport: 150,
                        whiteLabelSeoReports: true,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: 200,
                        leadGenWhitelabelReports: true,
                    }
                },],
                textualTarget: "for.large.seo.and.ppc.agencies",
                textualFeatures: [
                    "all.the.advanced.features",
                    "10.users.included",
                    "50.seo.projects",
                    "150.white.label.reports"
                ]
            },
            {
                name: 'Infinity',
                type: 'Agency',
                runningOut: false,
                annualInsteadAmount: 0,
                monthlyInsteadAmount: 0,
                annualAmount: 296,
                annualAmountDecimal: 0,
                monthlyAmount: 444,
                annualAmountSavedForYear: 1776,
                monthlyAmountSavedForYear: 0,
                trialPeriodDays: 7,
                annualAlias: 'plan-infinity-annual',
                monthlyAlias: 'plan-infinity-monthly',
                features: [{
                    platform: {
                        users: 25,
                        projects: 'Infinity'
                    },
                    seoAnalysis: {
                        analisysPerDay: 'Infinity',
                        onPageSeoCheck: true,
                        keywordReasearch: true,
                        contentAnalysis: true,
                        serpCompetitorAnalysis: true,
                    },
                    seoCopywritingAssistant: {
                        accessToTheTool: true,
                        suggestionsWithAI: true,
                        contentGeneration: true,
                    },
                    ai: {
                        accessToTheTool: true,
                        aiCredits: 4500,
                    },
                    onSiteSeoAudit: {
                        crawlablePagesPerMonth: 1250000,
                        pagesCanBeAnalyzedByProject: 25000,
                        dataRetention: '12 Months'
                    },
                    keywordResearch: {
                        resultsPerKeyword: 50000,
                        keywordPerDomainPerMonth: 150000,
                        keywordList: 'Infinity'
                    },
                    backlink: {
                        accessToTheTool: true,
                        backlinkRowsPerMonth: 1000000,
                        analisysPerMonth: 3000,
                    },
                    positionMonitoring: {
                        trackedKeyword: 5000,
                        updateFrequency: '3 Days',
                        searchEngines: 'Google / Yahoo / Bing',
                        mobileRanking: true,
                    },
                    report: {
                        exportCsvPerDay: 'Infinity',
                        dowloadableReport: 'Infinity',
                        whiteLabelSeoReports: true,
                    },
                    leadGeneration: {
                        formAllowed: 'Infinity',
                        leadIncludedPerMonth: 'Infinity',
                        leadGenWhitelabelReports: true,
                    }
                },],
                textualTarget: "for.highly.structured.marketing.agencies",
                textualFeatures: [
                    "all.the.premium.features",
                    "25.users.included",
                    "infinite.seo.projects",
                    "infinite.whitelabel.reports"
                ]
            },
        ];

        return {
            getAll: getAll,
            getPlansByType: getPlansByType,
            addFeaturesDetail: addFeaturesDetail,
            isPromoTime: isPromoTime,
            getCurrentPromo: getCurrentPromo,
            getPromoCalendar: getPromoCalendar,
            getPromoOptions: getPromoOptions,
            getPromoPreview: getPromoPreview,
            applyPromoToPlan: applyPromoToPlan,
            setPromoTimeToFalse: setPromoTimeToFalse
        };

        /**
         * @param plans
         * @param type
         * @returns {*}
         */
        function addFeaturesDetail(plans, type) {
            plans.map(function (plan) {
                plan.features = [];
                switch (plan.name) {
                    case 'Plan Lite':
                        plan.features = [{
                            text: 'access.seo.projects',
                            value: 1
                        },
                            {
                                text: 'access.analysis.per.day',
                                value: 25
                            },
                            {
                                text: 'access.monitored.keywords',
                                value: 25
                            },
                            {
                                text: 'access.scan.resources',
                                value: 250
                            },
                            {
                                text: 'access.backlink.analysis',
                                value: false,
                                showEver: true
                            },
                            {
                                text: 'access.whitelabel.reporting',
                                value: false,
                                showEver: true
                            },
                        ];
                        return;
                    case 'Plan Pro':
                        if (type === 'personal' || !type) {
                            plan.features = [{
                                text: 'access.seo.projects',
                                value: 2
                            },
                                {
                                    text: 'access.analysis.per.day',
                                    value: 100
                                },
                                {
                                    text: 'access.monitored.keywords',
                                    value: 150
                                },
                                {
                                    text: 'access.scan.resources',
                                    value: 2500
                                },
                                {
                                    text: 'access.downloadable.backlinks',
                                    value: 25000,
                                    showEver: true
                                },
                                {
                                    text: 'access.whitelabel.reporting',
                                    value: false,
                                    showEver: true
                                },

                            ];
                        } else if (type === 'personal pro') {
                            plan.features = [{
                                text: 'access.seo.projects',
                                value: 2
                            },
                                {
                                    text: 'access.analysis.per.day',
                                    value: 100
                                },
                                {
                                    text: 'access.monitored.keywords',
                                    value: 150
                                },
                                {
                                    text: 'access.scan.resources',
                                    value: 2500
                                },
                                {
                                    text: 'access.downloadable.backlinks',
                                    value: 25000,
                                },
                                {
                                    text: 'access.whitelabel.reporting',
                                    value: false,
                                },
                            ];
                        }
                        return;
                    case 'Plan Plus':
                        plan.features = [{
                            text: 'access.seo.projects',
                            value: 5,
                        },
                            {
                                text: 'access.analysis.per.day',
                                value: 200
                            },
                            {
                                text: 'access.monitored.keywords',
                                value: 500
                            },
                            {
                                text: 'access.scan.resources',
                                value: 10000
                            },
                            {
                                text: 'access.downloadable.backlinks',
                                value: 50000
                            },
                            {
                                text: 'access.whitelabel.reporting',
                                value: 25
                            },
                        ];
                        return;
                    case 'Plan Advanced':
                        plan.features = [{
                            text: 'access.users.included',
                            value: 5
                        },
                            {
                                text: 'access.seo.projects',
                                value: 15,
                            },
                            {
                                text: 'access.monitored.keywords',
                                value: 1000
                            },
                            {
                                text: 'access.scan.resources',
                                value: 50000
                            },
                            {
                                text: 'access.downloadable.backlinks',
                                value: 100000
                            },
                            {
                                text: 'access.whitelabel.reporting',
                                value: 50
                            },
                        ];
                        return;
                    case 'Plan Premium':
                        plan.features = [{
                            text: 'access.users.included',
                            value: 10
                        },
                            {
                                text: 'access.seo.projects',
                                value: 50
                            },
                            {
                                text: 'access.monitored.keywords',
                                value: 2500
                            },
                            {
                                text: 'access.scan.resources',
                                value: 500000
                            },
                            {
                                text: 'access.downloadable.backlinks',
                                value: 250000
                            },
                            {
                                text: 'access.whitelabel.reporting',
                                value: 150
                            },
                        ];
                        return;
                }
                return plan;
            });

            return plans;
        }

        /**
         * @returns {*[]|*}
         */
        function getAll() {
            var currentPromo = getCurrentPromo();
            if (currentPromo && currentPromo.promoType === 'all-platform-promo') {
                return self.plans.map(function (plan) {
                    return applyPromoToPlan(plan, currentPromo);
                });
            }

            return self.plans;
        }

        /**
         * @returns {*[]|*}
         */
        function getPlansByType(type) {
            var plans = getAll().filter(function (plan) {
                return plan.type === type;
            });


            if (!plans || plans.length <= 0) {
                plans = getAll().filter(function (plan) {
                    return plan.type === 'Agency';
                });
            }

            return plans;
        }

        function isPromoTime() {
            return !!getCurrentPromo();
        }

        function setPromoTimeToFalse() {
            self.isPromoTime = false;
        }

        function getCurrentPromo(nowValue) {
            var now = normalizeDate(nowValue);
            var promos = buildPromoStackForYear(getRomeYear(now));
            var previewPromotion = getPreviewPromotion(now);
            self.promoStack = promos;

            if (previewPromotion) {
                return previewPromotion;
            }

            var nowTimestamp = now.getTime();
            return promos.find(function (promo) {
                return nowTimestamp >= promo.startPromoDate.getTime()
                    && nowTimestamp < promo.endPromoDate.getTime();
            }) || null;
        }

        function getPromoCalendar(yearValue) {
            var year = parseInt(yearValue, 10) || getRomeYear(new Date());
            return buildPromoStackForYear(year);
        }

        function getPromoOptions() {
            return Object.keys(PROMO_DEFINITIONS).map(function (promotionId) {
                return {
                    id: promotionId,
                    name: PROMO_DEFINITIONS[promotionId].titleEmoji
                        + ' ' + PROMO_DEFINITIONS[promotionId].name,
                    discount: PROMO_DEFINITIONS[promotionId].discount
                };
            });
        }

        function getPromoPreview() {
            return getPreviewState();
        }

        function applyPromoToPlan(plan, promo) {
            var discountedPlan = Object.assign({}, plan);
            var annualPrice = Number(plan.annualAmount);
            var monthlyListPrice = Number(plan.monthlyAmount);
            var discountedAnnualPrice = roundMoney(annualPrice * (1 - (promo.discount / 100)));
            var discountedMonthlyPrice = roundMoney(monthlyListPrice * (1 - (promo.discount / 100)));
            var discountedParts = splitMoney(discountedAnnualPrice);
            var discountedMonthlyParts = splitMoney(discountedMonthlyPrice);

            discountedPlan.annualAmount = discountedParts.integer;
            discountedPlan.annualAmountDecimal = discountedParts.decimal || null;
            discountedPlan.annualAmountBeforePromo = annualPrice;
            discountedPlan.annualInsteadAmount = monthlyListPrice;
            discountedPlan.annualAmountSavedForYear = formatMoney(
                roundMoney((monthlyListPrice - discountedAnnualPrice) * 12),
            );
            if (!promo.annualOnly) {
                discountedPlan.monthlyAmount = discountedMonthlyParts.integer;
                discountedPlan.monthlyAmountDecimal = discountedMonthlyParts.decimal || null;
                discountedPlan.monthlyAmountBeforePromo = monthlyListPrice;
                discountedPlan.monthlyAmountSavedForYear = formatMoney(
                    roundMoney((monthlyListPrice - discountedMonthlyPrice) * 12),
                );
            }

            return discountedPlan;
        }

        function buildPromoStackForYear(year) {
            var easterDate = getEasterDate(year);
            var januaryBackToWorkDate = getFirstMondayAfterJanuaryFirst(year);
            var septemberBackToWorkDate = dateAtRomeMidnight(
                year,
                8,
                getFirstWeekdayDayOfMonth(year, 8, 1)
            );
            var firstFridayDay = getFirstWeekdayDayOfMonth(year, 10, 5);
            var firstThursdayDay = getFirstWeekdayDayOfMonth(year, 10, 4);
            var cyberMondayDay = firstThursdayDay + 25;
            var dayAfterCyberMonday = cyberMondayDay + 1;

            return [
                createPromo(
                    'newyear',
                    year,
                    dateAtRomeMidnight(year, 0, 1),
                    dateAtRomeMidnight(year, 0, 3)
                ),
                createPromo(
                    'backworkjan',
                    year,
                    dateAtRomeMidnight(year, 0, januaryBackToWorkDate.getUTCDate()),
                    addDays(dateAtRomeMidnight(
                        year,
                        0,
                        januaryBackToWorkDate.getUTCDate()
                    ), 7)
                ),
                createPromo(
                    'valentine',
                    year,
                    dateAtRomeMidnight(year, 1, 13),
                    dateAtRomeMidnight(year, 1, 15)
                ),
                createPromo(
                    'easter',
                    year,
                    dateAtRomeMidnight(
                        year,
                        easterDate.getUTCMonth(),
                        easterDate.getUTCDate()
                    ),
                    addDays(dateAtRomeMidnight(
                        year,
                        easterDate.getUTCMonth(),
                        easterDate.getUTCDate()
                    ), 7)
                ),
                createPromo(
                    'summer',
                    year,
                    dateAtRomeMidnight(year, 5, 21),
                    dateAtRomeMidnight(year, 6, 5)
                ),
                createPromo(
                    'ferragosto',
                    year,
                    dateAtRomeMidnight(year, 7, 14),
                    dateAtRomeMidnight(year, 7, 16)
                ),
                createPromo(
                    'backworksep',
                    year,
                    septemberBackToWorkDate,
                    addDays(septemberBackToWorkDate, 7)
                ),
                createPromo(
                    'halloween',
                    year,
                    dateAtRomeMidnight(year, 9, 30),
                    dateAtRomeMidnight(year, 10, 1)
                ),
                createPromo(
                    'black',
                    year,
                    dateAtRomeMidnight(year, 10, firstFridayDay),
                    dateAtRomeMidnight(year, 10, dayAfterCyberMonday)
                ),
                createPromo(
                    'cyber',
                    year,
                    dateAtRomeMidnight(year, 10, dayAfterCyberMonday),
                    dateAtRomeMidnight(year, 10, dayAfterCyberMonday + 7)
                ),
                createPromo(
                    'christmas',
                    year,
                    dateAtRomeMidnight(year, 10, dayAfterCyberMonday + 7),
                    dateAtRomeMidnight(year, 11, 26)
                ),
            ].sort(function (first, second) {
                return first.startPromoDate - second.startPromoDate;
            });
        }

        function createPromo(id, year, startDate, endDate) {
            var definition = PROMO_DEFINITIONS[id];

            return {
                id: id,
                name: definition.titleEmoji + ' ' + definition.name + ' ' + year,
                promoType: 'all-platform-promo',
                startPromoDate: startDate,
                endPromoDate: endDate,
                automatic: true,
                currentPromoModifierClass: definition.currentPromoModifierClass,
                promoImgFile: definition.promoImgFile,
                promoAlt: definition.promoAlt + ' ' + year,
                titleEmoji: definition.titleEmoji,
                titleText: definition.name + ' ' + year,
                illustrationEmojis: definition.illustrationEmojis,
                languageVisibility: definition.languageVisibility,
                discount: definition.discount,
                annualOnly: definition.annualOnly
            };
        }

        function getFirstWeekdayDayOfMonth(year, month, weekday) {
            var firstDay = new Date(Date.UTC(year, month, 1)).getUTCDay();
            return 1 + ((weekday - firstDay + 7) % 7);
        }

        function getFirstMondayAfterJanuaryFirst(year) {
            var firstCandidate = new Date(Date.UTC(year, 0, 2));
            var daysUntilMonday = (1 - firstCandidate.getUTCDay() + 7) % 7;
            return addDays(firstCandidate, daysUntilMonday);
        }

        function getEasterDate(year) {
            var a = year % 19;
            var b = Math.floor(year / 100);
            var c = year % 100;
            var d = Math.floor(b / 4);
            var e = b % 4;
            var f = Math.floor((b + 8) / 25);
            var g = Math.floor((b - f + 1) / 3);
            var h = (19 * a + b - d - g + 15) % 30;
            var i = Math.floor(c / 4);
            var k = c % 4;
            var l = (32 + 2 * e + 2 * i - h - k) % 7;
            var m = Math.floor((a + 11 * h + 22 * l) / 451);
            var month = Math.floor((h + l - 7 * m + 114) / 31);
            var day = ((h + l - 7 * m + 114) % 31) + 1;
            return new Date(Date.UTC(year, month - 1, day));
        }

        function addDays(date, days) {
            var shiftedDate = new Date(date);
            shiftedDate.setUTCDate(shiftedDate.getUTCDate() + days);
            return shiftedDate;
        }

        /*
         * Le campagne cadono sempre dopo il cambio dell'ora legale:
         * l'Italia è a UTC+1 e i confini restano coerenti anche con il server in UTC.
         */
        function dateAtRomeMidnight(year, month, day) {
            return new Date(Date.UTC(year, month, day) - (60 * 60 * 1000));
        }

        function getRomeYear(date) {
            return new Date(date.getTime() + (60 * 60 * 1000)).getUTCFullYear();
        }

        function normalizeDate(value) {
            if (value instanceof Date) {
                return value;
            }
            return new Date(value || Date.now());
        }

        function roundMoney(value) {
            return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
        }

        function splitMoney(value) {
            var integer = Math.floor(value);
            var decimal = Math.round((value - integer) * 100);

            if (decimal === 100) {
                return {integer: integer + 1, decimal: 0};
            }

            return {integer: integer, decimal: decimal};
        }

        function formatMoney(value) {
            return Number(value).toFixed(2).replace('.', ',');
        }

        function getPreviewPromotion(now) {
            var preview = getPreviewState();
            if (!preview) {
                return null;
            }

            var currentYear = getRomeYear(now);
            if (preview.year) {
                var requestedPromotion = buildPromoStackForYear(preview.year).find(function (item) {
                    return item.id === preview.promotion;
                });
                if (!requestedPromotion) {
                    return null;
                }

                var previewPromotion = Object.assign({}, requestedPromotion, {preview: true});
                if (previewPromotion.endPromoDate <= now) {
                    var previewDuration = Math.max(
                        1000,
                        previewPromotion.endPromoDate - previewPromotion.startPromoDate
                    );
                    previewPromotion.startPromoDate = new Date(now.getTime());
                    previewPromotion.endPromoDate = new Date(now.getTime() + previewDuration);
                    previewPromotion.countdownPreview = true;
                }
                return previewPromotion;
            }

            var promotions = buildPromoStackForYear(currentYear);
            var promotion = promotions.find(function (item) {
                return item.id === preview.promotion;
            });
            if (promotion && promotion.endPromoDate > now) {
                return Object.assign({}, promotion, {preview: true});
            }

            promotion = buildPromoStackForYear(currentYear + 1).find(function (item) {
                return item.id === preview.promotion;
            });
            return promotion ? Object.assign({}, promotion, {preview: true}) : null;
        }

        function getPreviewState() {
            if (typeof window === 'undefined' || !window.location) {
                return null;
            }

            var params = new URLSearchParams(window.location.search);
            var promotionId = params.get('promo');
            var previewToken = params.get('promoPreview');
            var previewYear = parseInt(params.get('promoYear'), 10);
            var storageKey = 'promoPreviewState';

            if (previewToken === 'off') {
                try {
                    window.localStorage.removeItem(storageKey);
                } catch (err) {
                    // localStorage can be unavailable in privacy-restricted browsers.
                }
                try {
                    window.sessionStorage.removeItem(storageKey);
                } catch (err) {
                    // Nothing else to clear.
                }
                return null;
            }

            if (promotionId && previewToken && PROMO_DEFINITIONS[promotionId]) {
                var preview = {promotion: promotionId, token: previewToken};
                if (previewYear >= 2000 && previewYear <= 2100) {
                    preview.year = previewYear;
                }
                try {
                    window.localStorage.setItem(storageKey, JSON.stringify(preview));
                    window.sessionStorage.removeItem(storageKey);
                } catch (err) {
                    try {
                        window.sessionStorage.setItem(storageKey, JSON.stringify(preview));
                    } catch (sessionError) {
                        return null;
                    }
                }
                return preview;
            }

            try {
                var storedPreview = window.localStorage.getItem(storageKey);
                if (storedPreview) {
                    return JSON.parse(storedPreview);
                }
            } catch (err) {
                // Fall through to the legacy session value below.
            }

            try {
                var sessionPreview = window.sessionStorage.getItem(storageKey);
                if (!sessionPreview) {
                    return null;
                }
                window.localStorage.setItem(storageKey, sessionPreview);
                window.sessionStorage.removeItem(storageKey);
                return JSON.parse(sessionPreview);
            } catch (err) {
                try {
                    window.sessionStorage.removeItem(storageKey);
                } catch (sessionError) {
                    // localStorage is unavailable and there is no usable session state.
                }
                return null;
            }
        }
    }
});
